import { HeaderView } from "./header";
import { ListView } from "./list";
import { ItemView } from "./item";
import { ScoreView } from "./score";
import { SettingsView } from "./settings";
import { SectionView } from "./section";
import { SummaryView } from "./summary";

import View from "./view";
export default View;

export { HeaderView, ListView, ItemView, ScoreView, SettingsView, SectionView, SummaryView, View };